export const normalizeLocationName = (value) => String(value || '')
  .trim()
  .replace(/\s+/g, ' ')
  .toLocaleLowerCase('en-US')
  .replace(/(^|[\s'’.-])(\p{L})/gu, (_, separator, letter) => `${separator}${letter.toLocaleUpperCase('en-US')}`);

// Preserve the trailing space and the user's casing while they type. Normalizing
// on every keypress made multi-word cities impossible to enter because `trim()`
// removed the space before the next word was written.
export const sanitizeCityInput = (value) => String(value || '')
  .replace(/[^\p{L}\p{M}\p{N} .,'’()-]/gu, '')
  .replace(/\s{2,}/g, ' ')
  .replace(/^\s+/, '')
  .slice(0, 100);

export const isValidCityName = (value) => {
  const city = String(value || '').trim();
  return city.length <= 100
    && /\p{L}/u.test(city)
    && /^[\p{L}\p{M}\p{N}][\p{L}\p{M}\p{N} .,'’()-]*$/u.test(city);
};
